const webinarButtonContainer = document.querySelector('[data-behaviour="webinar-load-more-show"]');
const webinarButton = document.querySelector('[data-behaviour="webinar-load-more"]');

if (webinarButtonContainer) {
	webinarButtonContainer.style.display = "flex";
}

if (webinarButton) {

	webinarButton.addEventListener('click', () => {
		// Elements
		const section = webinarButton.closest('[data-ref="webinar-list"]');
		const sectionInner = section.querySelector('[data-ref="webinar-inner"]');
		let activeNav = section.querySelector('[data-active="1"]');
		// Text
		const loadingSpan = '<span>.</span><span>.</span><span>.</span>'
		const loadingText = 'Loading' + loadingSpan;
		const defaultButtonText = 'Load more';
		//Disable Button
		webinarButton.disabled = true;
		webinarButton.innerHTML = loadingText;
		//Form Vars
		let activeKey = activeNav.dataset?.key;
		let paged = webinarButton.dataset?.paged;

		fetchwebinars(activeKey, paged)
			.then(response => {
				if (response.status === 'success' && response.html) {
					sectionInner.innerHTML += response.html;

					if (response.data &&
						!response.data.pagination
					) {
						webinarButton.classList.add('webinar-list__button--hidden');
					} else {
						webinarButton.classList.remove('webinar-list__button--hidden');
					}

				} else {
					console.log('Error during fetch response');
				}

				webinarButton.disabled = false;
				webinarButton.innerHTML = defaultButtonText;
			})
			.catch(error => {
				console.log('Error during fetch: ' + error);
			});
	});
}

const webinarsNav = document.querySelectorAll('[data-behaviour="webinar-two-filter"]');

if (webinarsNav.length) {
	// Elements
	const section = webinarsNav[0].closest('[data-ref="webinar-list"]');
	const sectionInner = section.querySelector('[data-ref="webinar-inner"]');

	webinarsNav.forEach(el => {
		el.addEventListener('click', () => {
			//disabled buttons
			webinarsNav.forEach(button => {
				button.disabled = true;
			});

			//Form Els
			const activeKey = el.dataset?.key;
			const paged = 1; // will always be 1 on first click
			const activeNav = section.querySelector('[data-active="1"]');

			fetchwebinars(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							webinarButton.classList.add('webinar-list__button--hidden');
						} else {
							webinarButton.classList.remove('webinar-list__button--hidden');
						}

						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');

						el.dataset.active = 1;
						el.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}

					//enable buttons
					webinarsNav.forEach(button => {
						button.disabled = false;
					});
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});
		});
	});

	const selectFilter = document.querySelector('[data-select="ebook-whitpaper-filter"]');
	if (selectFilter) {
		selectFilter.addEventListener('change', (e) => {
			let activeKey = e.target.value; //category id
			const paged = 1; // will always be 1 on first click

			fetchwebinars(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							webinarButton.classList.add('blog-post-list__button--hidden');
						} else {
							webinarButton.classList.remove('blog-post-list__button--hidden');
						}
						let activeNav = section.querySelector('[data-active="1"]');
						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');
						//button on nav
						let getFilterNav =  section.querySelector(`[data-key="${activeKey}"]`)//just in case resize
						getFilterNav.dataset.active = 1;
						getFilterNav.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});

		});
	}
}

/**
 * fetchwebinars
 * @param {Number} activeKey TermId
 * @param {Number} paged Default 1
 * @returns JSON response (Webinars)
 */
const fetchwebinars = async ( activeKey, paged = 1 ) => {
	// FORM
	const formData = new FormData();
	formData.set('security', wp_ajax.security);
	formData.set('activeKey', activeKey);
	formData.set('paged', paged);

	const response = await fetch(`${wp_ajax.ajax_url}?action=webinar_load_more`, {
		method: 'POST',
		body: formData
	})

	if (!response.ok) {
		const message = `An error has occured: ${response.status}`;
		throw new Error(message);
	}

	const Webinars = await response.json();

  	return Webinars;
}
